// extracted by mini-css-extract-plugin
export default {"instruction-item-container":"HBxMP","instructionItemContainer":"HBxMP","appear-from-above":"Z_CHF","appearFromAbove":"Z_CHF"};